module.exports = "/packs/013-315d0a73bffe7e0447d74d57b017cc77.jpg";